import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { formEarlyRegistrationSelector } from "../redux/selector";
import { createEarlyRegistrationApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";
import {
  earlyRegistrationSuccess,
  earlyRegistrationStart,
  earlyRegistrationFailed,
  setEarlyRegistrationFormInput,
} from "../redux/earlyRegistation";

function* earlyRegistrationWork(action) {
  const formData = yield select(formEarlyRegistrationSelector);

  try {
    const newFormData = {
      approvals: formData?.approvals?.map((it) => it?.value),
      files: formData?.files?.filter((it) => !!it),
      startWorkingDate: formData?.startWorkingDate,
      registerLeaveId: formData?.registerLeaveId,
    };
    const { callback, screenCode } = action.payload;
    const res = yield call(createEarlyRegistrationApi, screenCode, newFormData);
    if (res) {
      toast.success("Đăng ký đơn đi làm sớm thành công");
      yield put({
        type: earlyRegistrationSuccess.type,
      });

      callback?.();
    }
  } catch (error) {
    toast.error(error?.response?.data?.message ?? "Có lỗi xảy ra");
    yield put({
      type: earlyRegistrationFailed.type,
    });
    yield put({
      type: setEarlyRegistrationFormInput.type,
      payload: {
        files_file_contents: [],
        files_files: [],
      },
    });
  }
}

function* watchEarlyRegistration() {
  yield takeLatest(earlyRegistrationStart.type, earlyRegistrationWork);
}

export default function* earlyRegistrationSaga() {
  yield all([watchEarlyRegistration()]);
}
